import { render, staticRenderFns } from "./fulfillment-picking-queue-details.vue?vue&type=template&id=4b739100&scoped=true&"
import script from "./js/fulfillment-picking-queue-details.js?vue&type=script&lang=js&"
export * from "./js/fulfillment-picking-queue-details.js?vue&type=script&lang=js&"
import style0 from "./fulfillment-picking-queue-details.vue?vue&type=style&index=0&id=4b739100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b739100",
  null
  
)

export default component.exports